import Button from 'components/Button/Button';
import {templates} from 'features/beersManager/typescript';
import {setActiveTemplateAC} from 'features/postGenerator/slice';
import {useGlobalState} from 'hooks/useGlobalState';
import {useSetGlobalState} from 'hooks/useSetGlobalState';
import Slider from 'react-slick';

import 'slick-carousel/slick/slick-theme.css';
import 'slick-carousel/slick/slick.css';
import './TemplateSlider.scss';

export default function TemplateSlider() {
  const dispatch = useSetGlobalState();
  const {activeTemplate} = useGlobalState((state) => state.postGenerator);

  const handleSetActiveTemplate = (template: templates.Standard | templates.Standard2) => {
    dispatch(setActiveTemplateAC(template));
  };

  return (
    <div className="template-slider">
      <div className="template-slider__overlay"> </div>
      <Slider
        speed={300}
        slidesToShow={5}
        slidesToScroll={1}
        centerPadding="10"
        dots={false}
        arrows={false}
        infinite={false}
        centerMode={false}
        swipeToSlide
      >
        <div
          className={`template-slider__item ${
            activeTemplate === templates.Standard ? 'template-slider__item--active' : ''
          }`}
        >
          <Button
            variant="default"
            style={{background: 'url(images/standard-template-preview.png)', backgroundSize: 'contain'}}
            onClick={() => handleSetActiveTemplate(templates.Standard)}
          />
        </div>
        <div
          className={`template-slider__item ${
            activeTemplate === templates.Standard2 ? 'template-slider__item--active' : ''
          }`}
        >
          <Button
            variant="default"
            style={{background: 'url(images/standard-template-2-preview.png)', backgroundSize: 'contain'}}
            onClick={() => handleSetActiveTemplate(templates.Standard2)}
          />
        </div>
      </Slider>
    </div>
  );
}
